module.exports = __webpack_public_path__ + "assets/media/hqh.a2dd0520.mp4";